module.exports = __webpack_public_path__ + "components/breakheader/static/icon--alert-75f21e2d40b0750c0db4c01a60e8076b.svg";